<div class="radio">
  <input
    id="{{ id }}"
    name="{{ name }}"
    type="radio"
    [value]="value"
    [checked]="checked"
    [disabled]="disabled"
    (change)="onChange($event)"
  />
  <label for="{{ id }}" class="radio-label">
    <ng-content></ng-content>
  </label>
</div>
